/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import logo from "../../assets/images/wanderobe-logo-1.svg";
import StyledPaymentSuccess from "./StyledPaymentSuccess";
import { ROUTE_PATH } from "../../constants/route";
import { useNavigate } from "react-router-dom";

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const [timer, setTimer] = useState(5);

  useEffect(() => {
    const interval = setInterval(() => {
      setTimer((prevTimer) => prevTimer - 1);
    }, 1000);

    if (timer === 0) {
      handleNavigation();
    }

    return () => clearInterval(interval);
  }, [timer]);

  const handleNavigation = () => {
    const navigateUser = localStorage.getItem("createProfilePayment");
    if (navigateUser) {
      navigate(ROUTE_PATH?.CREATE_PROFILE);
      localStorage.removeItem("createProfilePayment");
    } else {
      navigate(ROUTE_PATH?.PAYMENTS);
    }
  };
  return (
    <StyledPaymentSuccess>
      <Box className='payment-success-logo'>
        <img src={logo} alt='logo' style={{ width: "186px" }} />
      </Box>
      <Box className='payment-success-text-wrap'>
        <Typography className='payment-success-header'>
          Please close the window, or it will close automatically in {timer} seconds.
        </Typography>
        <Button
          variant='contained'
          color='primary'
          className='payment-success-btn'
          onClick={() => handleNavigation()}
        >
          Close Window
        </Button>
      </Box>
    </StyledPaymentSuccess>
  );
};

export default PaymentSuccess;
